import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa738712")

_pushScopeId("data-v-aa738712")
const _hoisted_1 = { class: "row gy-5 g-xl-8 mb-5 mb-xl-10 tableOpacity" }
const _hoisted_2 = { class: "card order-widget card-p d-flex flex-wrap align-items-center justify-content-between flex-row" }
const _hoisted_3 = { class: "w-75" }
const _hoisted_4 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "20%",
  height: "26"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "28%",
  height: "21"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "70",
  rx: ".5rem",
  ry: ".5rem",
  width: "46%",
  height: "38"
}, null, -1)
const _hoisted_7 = { class: "w-25 text-end" }
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "15",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "82",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "20"
}, null, -1)
const _hoisted_10 = { class: "row gy-5 gx-xl-8 mb-5 mb-xl-10 tableOpacity" }
const _hoisted_11 = { class: "col-xl-12" }
const _hoisted_12 = { class: "card order-widget card-p" }
const _hoisted_13 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "8%",
  height: "26"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "12%",
  height: "21"
}, null, -1)
const _hoisted_16 = { class: "d-flex flex-wrap" }
const _hoisted_17 = { style: {"width":"56px"} }
const _hoisted_18 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "2vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "45",
  height: "18"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "7vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "56",
  height: "18"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "12vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "34",
  height: "18"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "17vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "50",
  height: "18"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "22vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "40",
  height: "18"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "27vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "56",
  height: "18"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "32vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "50",
  height: "18"
}, null, -1)
const _hoisted_25 = { style: {"border":"solid #ccc","border-width":"0 0 1px 1px","margin":"0 0 0 20px","width":"84%","padding":"0 18px","display":"flex","flex-wrap":"wrap","justify-content":"space-between","align-items":"flex-end"} }
const _hoisted_26 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "22vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "12vh"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "9vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "25vh"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "26vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "8vh"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "20vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "14vh"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "14vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "20vh"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "2vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "32vh"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "29vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "5vh"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "16vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "18vh"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "8vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "26vh"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "24vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "10vh"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: "0",
  ry: "0",
  width: "24",
  height: "34vh"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "32vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "2vh"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "4vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "30vh"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "8vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "26vh"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "16vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "18vh"
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "22vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "12vh"
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "14vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "20vh"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "10vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "24vh"
}, null, -1)
const _hoisted_44 = { class: "row gy-5 gx-xl-8 tableOpacity" }
const _hoisted_45 = { class: "col-xl-8" }
const _hoisted_46 = { class: "card order-widget card-p" }
const _hoisted_47 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "8%",
  height: "26"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "12%",
  height: "21"
}, null, -1)
const _hoisted_50 = { class: "d-flex flex-wrap" }
const _hoisted_51 = { style: {"width":"56px"} }
const _hoisted_52 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "2vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "45",
  height: "18"
}, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "7vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "56",
  height: "18"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "12vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "34",
  height: "18"
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "17vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "50",
  height: "18"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "22vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "40",
  height: "18"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "27vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "56",
  height: "18"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "32vh",
  rx: ".5rem",
  ry: ".25rem",
  width: "50",
  height: "18"
}, null, -1)
const _hoisted_59 = { style: {"border":"solid #ccc","border-width":"0 0 1px 1px","margin":"0 0 0 10px","width":"80%","padding":"0 18px","display":"flex","flex-wrap":"wrap","justify-content":"space-between","align-items":"flex-end"} }
const _hoisted_60 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "22vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "12vh"
}, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "9vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "25vh"
}, null, -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "26vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "8vh"
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "20vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "14vh"
}, null, -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "14vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "20vh"
}, null, -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "2vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "32vh"
}, null, -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "29vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "5vh"
}, null, -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "16vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "18vh"
}, null, -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "8vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "26vh"
}, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "24vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "10vh"
}, null, -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: "0",
  ry: "0",
  width: "24",
  height: "34vh"
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "32vh",
  rx: "0",
  ry: "0",
  width: "24",
  height: "2vh"
}, null, -1)
const _hoisted_72 = { class: "col-xl-4" }
const _hoisted_73 = { class: "card order-widget card-p" }
const _hoisted_74 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "56",
  height: "56"
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "0",
  rx: ".5rem",
  ry: ".5rem",
  width: "24%",
  height: "26"
}, null, -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("rect", {
  x: "70",
  y: "37",
  rx: ".5rem",
  ry: ".5rem",
  width: "38%",
  height: "21"
}, null, -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("circle", {
  cx: "50%",
  cy: "60%",
  r: "36%"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
        return _createVNode("div", {
          class: "col-md-6 col-xl-4",
          key: i
        }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_content_loader, {
                width: "100%",
                height: "112",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#ccc"
              }, {
                default: _withId(() => [
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_content_loader, {
                width: "56",
                height: "112",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ])
        ])
      }), 64))
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_content_loader, {
            width: "100%",
            height: "90",
            speed: 2,
            primaryColor: "#ababab",
            secondaryColor: "#cccccc"
          }, {
            default: _withId(() => [
              _hoisted_13,
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_content_loader, {
                width: "90",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_26
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_27
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_28
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_29
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_30
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_31
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_32
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_33
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_34
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_35
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_36
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_37
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_38
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_39
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_40
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_41
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_42
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_43
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_44, [
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode(_component_content_loader, {
            width: "100%",
            height: "90",
            speed: 2,
            primaryColor: "#ababab",
            secondaryColor: "#cccccc"
          }, {
            default: _withId(() => [
              _hoisted_47,
              _hoisted_48,
              _hoisted_49
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_50, [
            _createVNode("div", _hoisted_51, [
              _createVNode(_component_content_loader, {
                width: "90",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_52,
                  _hoisted_53,
                  _hoisted_54,
                  _hoisted_55,
                  _hoisted_56,
                  _hoisted_57,
                  _hoisted_58
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_59, [
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_60
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_61
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_62
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_63
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_64
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_65
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_66
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_67
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_68
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_69
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_70
                ]),
                _: 1
              }),
              _createVNode(_component_content_loader, {
                width: "24",
                height: "34vh",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#cccccc"
              }, {
                default: _withId(() => [
                  _hoisted_71
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_72, [
        _createVNode("div", _hoisted_73, [
          _createVNode(_component_content_loader, {
            width: "100%",
            height: "44vh",
            speed: 2,
            primaryColor: "#ababab",
            secondaryColor: "#cccccc"
          }, {
            default: _withId(() => [
              _hoisted_74,
              _hoisted_75,
              _hoisted_76,
              _hoisted_77
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
})